import React from "react";
import { Navigate } from "react-router-dom";

export default function TripReviewRedirect(props) {
  return (
    <Navigate
      replace
      to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
      state={{ trip_id: props.trip_id, client_id: props.client_id }}
    />
  );
}
